
import "./Purchasing.css";
import icon9 from "../Icons/Icon-09.png";
import { showRegister } from "../Redux/HomeSlice";
import { searsh_product } from "../Redux/HomeSlice";
import img2 from "../images/IMG-20240723-WA0008.jpg";
import img3 from "../images/IMG-20240723-WA0013.jpg";
import img4 from "../images/IMG-20240723-WA0018.jpg";
import img5 from "../images/IMG-20240723-WA0021.jpg";
import img6 from "../images/IMG-20240723-WA0022.jpg";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useState, useEffect } from "react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import market_icon_2 from '../images/market_icon_2.svg';
import Register from "../Register/Register";
import PaymentProcess from "../PaymentProcess/PaymentProcess";
import Searsh from "../Searsh/Searsh";

import {
  get_cart,
  favorites,
  product_reviews,
  delete_cart,
  recommended,
  total_cart,
  product_details,
  update_cart,
  apply_coupon,
  remove_favorites,
  addFavorite,
  payment_status
} from "../Redux/API";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import { show_brand, show_Influencer, show_store} from '../Redux/API';

function Purchasing() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loadingDelete_cart = useSelector(
    (state) => state?.Data.loadingDelete_cart
  );
  const loadingTotal_cart = useSelector(
    (state) => state.Data.loadingTotal_cart
  );
  const loadingUpdate_cart = useSelector(
    (state) => state.Data.loadingUpdate_cart
  );
  const loadingPayment_cod = useSelector(
    (state) => state.Data.loadingPayment_cod
  );
  const Payment_cods  = useSelector(state => state.Data.payment_cod );


  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token = valueLocalStorage?.data?.token || null;

  const showR = useSelector((state) => state?.products?.showR);
  const get_cart_data = useSelector((state) => state.Data.get_cart);
  const total_carts = useSelector((state) => state.Data.total_cart);
  const loadingGet_cart = useSelector((state) => state.Data.loadingGet_cart);
  console.log(get_cart_data)

  const [updatedQuantity, setUpdatedQuantity] = useState({});  // لتخزين الكمية المحدثة

  const increment = (index, id, colorId, sizeId) => {
    const currentQuantity = updatedQuantity[index] || get_cart_data?.data?.data?.items[index]?.quantity || 1;
    const newQuantity = currentQuantity + 1;
    setUpdatedQuantity((prev) => ({
      ...prev,
      [index]: newQuantity,
    }));

    dispatch(update_cart({id, size_id: sizeId, color_image_id: colorId, quantity: newQuantity}));
  };

  const decrement = (index, id, colorId, sizeId) => {
    const currentQuantity = updatedQuantity[index] || get_cart_data?.data?.data?.items[index]?.quantity || 1;
    const newQuantity = Math.max(currentQuantity - 1, 1);
    setUpdatedQuantity((prev) => ({
      ...prev,
      [index]: newQuantity,
    }));
    dispatch(update_cart({id, size_id: sizeId, color_image_id: colorId, quantity: newQuantity}));
  };



  
  

  const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
  const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);
  const loadingAddFavorite = useSelector((state) => state.Data.loadingAddFavorite);

  useEffect(() => {
    if (!loadingAddFavorite && !loadingRemove_favorites) {
      dispatch(favorites()); // قم بتحديث المفضلة بعد الإضافة أو الحذف
    }
  }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);

  const handelAdd_wishlist = (id, event) => {
    if (token) {
      const isInWishlist = favorite?.some((item) => item.product_id === id);
      if (isInWishlist) {
        dispatch(remove_favorites(id));
      } else {
        dispatch(addFavorite({ id }));
      }
    } else {
      const { pageY } = event;
      const offsetY = -100; // إزاحة بسيطة لعرض الـ Popup تحت النقطة قليلاً
      setPopupPosition({ x: 50, y: pageY + offsetY }); // X في المنتصف باستخدام نسبة 50%، Y عند النقطة التي تم الضغط عليها
      dispatch(showRegister(true));
    }
  };

  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };

  const recommendeds = useSelector((state) => state.Data.recommended);
  const loadingRecommended = useSelector(
    (state) => state.Data.loadingRecommended
  );
  const gotoProductDetails = (product) => {
    localStorage.setItem("Product_id", product.id);
    dispatch(product_details(product.id));
    dispatch(product_reviews(product.id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));


    const id = product?.type?.id;
    if (!id || !product?.vendor_type) return;

    switch (product.vendor_type) {
      case "brand":
          localStorage.setItem('brandId', id);
          dispatch(show_brand({ id }));
          break;
      case "influencer":
          localStorage.setItem('InfluencerId', id);
          dispatch(show_Influencer({ id }));
          break;
      case "store":
          localStorage.setItem('storeId', id);
          dispatch(show_store({ id }));
          break;
      default:
          console.error("Unknown vendor type:", product.vendor_type);
    }
  };
  const imagess1 = recommendeds?.data?.data || [];

  const [startIndex1, setStartIndex1] = useState(0);

  const handleNext1 = () => {
    if (startIndex1 + 5 < imagess1?.length) {
      setStartIndex1(startIndex1 + 1);
    }
  };

  const handlePrev1 = () => {
    if (startIndex1 > 0) {
      setStartIndex1(startIndex1 - 1);
    }
  };
  const images_difalt = [
    {
      src: img2,
      title: "Photo 1",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img2,
      title: "Photo 2",
      p: "AMERIX BIO TIN 60 PIECES hello mohamed",
      price: "469.000",
    },
    {
      src: img3,
      title: "Photo 3",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img4,
      title: "Photo 4",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img5,
      title: "Photo 5",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img6,
      title: "Photo 6",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
    {
      src: img6,
      title: "Photo 6",
      p: "AMERIX BIO TIN 60 PIECES",
      price: "469.000",
    },
  ];

  const getVisibleCountProduct = () => {
    if (window.innerWidth >= 1400) return 5; // شاشات XL
    if (window.innerWidth >= 1200) return 5; // شاشات LG
    if (window.innerWidth >= 992) return 4; // شاشات MD
    if (window.innerWidth >= 768) return 3; // شاشات SM
    if (window.innerWidth >= 576) return 3; // شاشات SM
    return 2;
  };


  const [startIndex8, setStartIndex8] = useState(0);
  const getVisibleImages8 = () => {
    return images_difalt?.slice(startIndex8, startIndex8 + getVisibleCountProduct());
  };

 const getVisibleImages1 = () => {
    return imagess1?.slice(startIndex1, startIndex1 + getVisibleCountProduct());
  };


  const delete_cartS = (id, colorId, sizeId) => {
    dispatch(delete_cart({ id, size_id: sizeId, color_image_id: colorId }))
      .then(() => {
        if (get_cart_data?.data?.data?.items?.length === 1) {
          window.location.reload(); // إعادة تحميل الصفحة
        } else {
          dispatch(get_cart());
        }
      });
  };

  const show_searsh = useSelector((state) => state?.products?.searsh);
  const images = get_cart_data?.data?.data?.items || [];



const loadingApply_coupon = useSelector(
  (state) => state.Data.loadingApply_coupon
);
const errorApply_coupon = useSelector(
  (state) => state.Data.errorApply_coupon
);

const [showPopup, setShowPopup] = useState(false);

useEffect(() => {
  if (errorApply_coupon) {
    setShowPopup(true);
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 3000);

    return () => clearTimeout(timer); 
  }
}, [errorApply_coupon]);

useEffect(() => {
  dispatch(recommended());
  dispatch(total_cart());
  dispatch(payment_status());
}, [dispatch, loadingApply_coupon]);

const [coupon_code, setCoupon_code] = useState(""); 

const handleAddCoupon = () => {
  if (coupon_code.trim()) {
    dispatch(apply_coupon({coupon_code})); 
  } else {
  }
};

useEffect(() => {
  if (loadingDelete_cart || loadingUpdate_cart === false) {

  dispatch(total_cart());
  }
}, [dispatch, loadingDelete_cart, loadingUpdate_cart]);


useEffect(() => {
    dispatch(get_cart());
}, [dispatch, loadingUpdate_cart]);

const [totalQuantity, setTotalQuantity] = useState(0);
useEffect(() => {
  if (loadingUpdate_cart === false) {
    const total = get_cart_data?.data?.data?.items?.reduce((sum, item) => {
      return sum + (item.quantity || 0);
    }, 0);

    setTotalQuantity(total || 0);
  }
}, [loadingUpdate_cart, get_cart_data]);

const gotoHome = () => {
  navigate("/");
  window.scrollTo(0, 0);
};

const [showPayment, setShowPayment] = useState(false);
const showPaymentButton = () => {
  setShowPayment(!showPayment)
};


console.log(showPayment)
  return (
    <div className="Purchasing">
      <Header />
      {showR && (
                <div className="overlay">
                <div
                    className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
                    style={{
                    position: "absolute",
                    top: `${popupPosition.y}px`,
                    left: "50%",
                    transform: "translateX(-50%)",
                    margin: "auto",
                    zIndex: 4,
                    padding: "0px",
                    }}
                >
                    <Register />
                </div>
                </div>
            )}

      {show_searsh && (
        <Searsh />
      )}
      {loadingDelete_cart && <Loader />}
      {loadingApply_coupon && <Loader />}
      <div className="container_Purchasing container mt-m-2">

      {images?.length === 0 && (
        <>
  <div className="empty-cart">
    <img src={market_icon_2} alt="Empty Cart" />
  </div>


               <div className="empty-favorites text-center">
  <p>{t("Your cart is empty !")}</p>
  <button className="btn btn-primary" onClick={gotoHome}>
    {t("Add Products to Cart")}
  </button>
</div>

               </>
)}
      {showPopup && (
        <div className="popup">
          <p>{errorApply_coupon?.message}</p>
        </div>
      )}

      {get_cart_data?.data?.data?.items.map((item, index) => (
          <div key={index} className="container_prodects row justify-content-between">
            <div className="col-12 col-md-6 col-lg-4 text-center">
              <img src={item.main_image} alt="product" />
            </div>
            <div className="details col-12 col-md-6 col-lg-4">
              <p>{item.nike}</p>
              <p>{t("color")}</p>
              <div className="d-flex">
                <div className="img_color">
                  <img src={item?.colors?.image} alt="color" />
                </div>
              </div>
              <p className="mt-3">{t("size")}</p>
              <div className="d-flex">
                <div className="img_color d-flex">
                  <span>{item?.sizes?.size}</span>
                </div>
              </div>
            </div>
            <div className="box_counter col-12 col-md-6 col-lg-4 mt-sm-3 text-center">
              <div className="counter">
                <span
                  className="span1"
                  onClick={() => decrement(index, item.id, item.colors?.id, item.sizes?.id)} 
                >
                  -
                </span>
                <span className="span3">
                  {updatedQuantity[index] || item.quantity}  
                </span>
                <span
                  className="span2"
                  onClick={() => increment(index, item.id, item.colors?.id, item.sizes?.id)}
                >
                  +
                </span>
              </div>
              <i>
                <FontAwesomeIcon
                  icon={faTrash}
                  onClick={() => delete_cartS(item.id, item.colors?.id, item.sizes?.id)}
                />
              </i>
              <p>
                <span>KWD</span>
                {item.new_price}
              </p>
            </div>
          </div>
        ))}

      </div>

      <div className="Vouchers container">
        <div className="row justify-content-end">
          <div className="Quantity col col-md-7 col-lg-6">
            <div>
              <p>{t("total_quantity")}</p>
              <p className="p2">{totalQuantity}</p>
              <p>{t("total_price")}</p>
              <p className="p3">
                {total_carts?.data.data.total} <span>KWD</span> 
              </p>
            </div>
            <div className="Promos">
              <span onClick={handleAddCoupon} style={{ cursor: "pointer" }}>
                {t('addCoupon')}
              </span>
              <input
                type="text"
                placeholder={t('enterCoupon')} 
                value={coupon_code}
                onChange={(e) => setCoupon_code(e.target.value)}
              />
            </div>


            <div className="Promos2">
              <span>{t("discount_voucher")}</span>
              <span className="Discount">
                -{total_carts?.data.data.discount}

                <span className="KWD"> KWD </span>
              </span>
            </div>
            <div className="Promos2">
              <span>{t("shipping_fee")}</span>
              <span>
              {total_carts?.data.data.shipping}
                <span className="KWD"> KWD</span>
              </span>
            </div>
            <div className="Promos">
              <span>{t("total_price")}</span>
              <span>
              {total_carts?.data.data.total}
                <span className="KWD border-0"> KWD</span>
              </span>
            </div>
            <div className="checkout_now_button" onClick={ showPaymentButton}>{t("checkout_now")}</div>
          </div>
        </div>
      </div>
      {showPayment && <PaymentProcess showPaymentButton={showPaymentButton}/>}

      <div className="container">
        <p>{t("new_customers")}</p>
      </div>

      <div className="gallery1 container">
        {loadingRecommended && <Loader />}

        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev1} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
        {(getVisibleImages1()?.length > 0
            ? getVisibleImages1()
            : getVisibleImages8()
          ).map((product, index) => {
            const isInWishlist = favorite?.some(
              (item) => item.product_id === product.id
            ); 

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                    <div className="padding_box"onClick={() => gotoProductDetails(product)} >
                    <i
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="ده التولتيب بتاعي"
                      onClick={(event) => {
                        handelAdd_wishlist(product.id, event);
                        event.stopPropagation();

                      }}
                      style={{ color: isInWishlist ? "red" : "white" }}
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext1} />
        </div>
      </div>

      <Footer Sign_Up={Sign_Up} />
    </div>
  );
}

export default Purchasing;
